import { defineStore } from 'pinia';
import { CountryUtil, type ClassificationMonitor, Constants } from '@fibl/oxs-common';
import * as SearchRepo from '@/repository/search';
import { EAV } from '@fibl/zdb-common';

type Ent = EAV.Entity<ClassificationMonitor.ClassificationMonitor>;

export const useClassificationMonitorStore = defineStore('classificationMonitor', {
	state: () => ({
		monitors: [] as Ent[],
	}),

	getters: {
		byCountry() {
			return (country: CountryUtil.CountryCode) => {
				return this.monitors.find((e) => e.data.country === country);
			};
		},
	},

	actions: {
		async loadByCountry(cc: string) {
			const res: Ent[] = await SearchRepo.findAll(
				Constants.CLASSIFICATION_MONITOR_CONTEXT_KEY_PREFIX,
				{
					$and: [
						{
							field: '/data/country',
							comparison: 'eq',
							value: cc,
						},
					],
				},
			);
			if (res.length > 0) {
				this.monitors = res;
			}
		},
		addToMonitors(ent: Ent) {
			this.monitors.push(ent);
		},
	},
});
